import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./Pages/login";
import Dashboard from "./Pages/dashboard";
import Profile from "./Pages/profile";
import Userprofile from "./Pages/userprofile";
import Wallet from "./Pages/wallet";
import Cart from "./Pages/cart";
import Userinfo from "./Pages/userinfo";
import ForgotPassword from "./Pages/forgotPassword";
import Register from "./Pages/register";
import Leaderboard from "./Pages/leaderboard";
import { AuthProvider } from "./contexts/AuthContext";
import WalletCharge from "./Pages/walletcharge";
import PaymentCallback from "./Pages/paymentcallback";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <AuthProvider>
                    <Routes>
                        <Route path="/" element={<Login />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/forgotpassword" element={<ForgotPassword />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/profile/:id/" element={<Userprofile />}></Route>
                        <Route path="/userinfo" element={<Userinfo />} />
                        <Route path="/leaderboard" element={<Leaderboard />} />
                        <Route path="/cart" element={<Cart />} />
                        <Route path="/wallet" element={<Wallet />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/wallet/charge" element={<WalletCharge />} />
                        <Route path="/payment/callback" element={<PaymentCallback />} />
                    </Routes>
                </AuthProvider>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;